<style lang="less">
@import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card title="小程序文字配置栏目">
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">新增</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" size="small" :data="data" sortable="custom"
                               @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                        <Modal v-model="picVisible" title="图片" draggable>
                            <img :src="img" alt="无效的图片链接" style="width: 100%;margin: 0 auto;display: block;">
                        </Modal>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize"
                              @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]"
                              size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <indextag-drawer ref="indextagDrawer"></indextag-drawer>
    </div>
</template>

<script>
import circleLoading from "../../my-components/circle-loading.vue";
import {textList,removebyIds,getText,addText,editTextStatus} from "@/api/bus";
import indextagDrawer from "./index-drawer";

export default {
    name: "indextag-manage",
    components: {
        indextagDrawer,
        circleLoading
    },
    data() {
        return {
            text: "",
            img: "",
            picVisible: false,
            loading: false, // 表单加载状态
            drop: false,
            selectCount: 0, // 多选计数
            selectList: [], // 多选数据
            dropDownContent: "展开",
            dropDownIcon: "ios-arrow-down",
            searchForm: {
                pageNumber: 1, // 当前页数
                pageSize: 10, // 页面大小
                //  sort: "sort", // 默认排序字段
                // order: "asc", // 默认排序方式
            },
            selectDate: null, //选择日期绑定modal
            columns: [
                {
                    type: "index",
                    width: 100,
                    align: "center"
                },
                {
                    title: "模块名称",
                    align: "center",
                    key: "title"
                },
                {
                    title: "分组",
                    align: "center",
                    key: "type",
                    render: (h, params) => {
                        let re = "";
                     if (params.row.type === 1) {
                            return h("div", [
                                h(
                                    "Tag",
                                    {
                                        props: {
                                            color: "#8E98FA"
                                        }
                                    },
                                    "新闻栏目"
                                )
                            ]);
                        }
                       else if (params.row.type === 2) {
                            return h("div", [
                                h(
                                    "Tag",
                                    {
                                        props: {
                                            color: "#70B603"
                                        }
                                    },
                                    "学习/考试栏目"
                                )
                            ]);
                        } else if (params.row.type === 3) {
                            return h("div", [
                                h(
                                    "Tag",
                                    {
                                        props: {
                                            color: "#2545FA"
                                        }
                                    },
                                    "评价/认定栏目"
                                )
                            ]);
                        }
                     else if (params.row.type === 4) {
                         return h("div", [
                             h(
                                 "Tag",
                                 {
                                     props: {
                                         color: "#767676"
                                     }
                                 },
                                 "首页标题"
                             )
                         ]);
                     }
                     else if (params.row.type === 5) {
                         return h("div", [
                             h(
                                 "Tag",
                                 {
                                     props: {
                                         color: "#767676"
                                     }
                                 },
                                 "个人中心背景"
                             )
                         ]);
                     }

                    }
                },
                {
                    title: "排序",
                    align: "center",
                    key: "sortOrder"
                },
                {
                    title: "是否展示",
                    key: "deleted",
                    align: "center",
                    width: 100,
                    render: (h, params) => {
                        return h(
                            "i-switch",
                            {
                                props: {
                                    value: params.row.deleted,
                                    size: "large",
                                    "true-value": 0,
                                    "false-value": 1,
                                },
                                on: {
                                    "on-change": (v) => {
                                        params.row.deleted = v;
                                        this.setStatus(params.row, v);
                                    },
                                },
                            },
                            [
                                h("span", { slot: "open" }, "显示"),
                                h("span", { slot: "close" }, "隐藏"),
                            ]
                        );
                    },
                },
                {
                    title: "修改时间",
                    align: "center",
                    key: "updateTime"
                },
                {
                    title: "操作",
                    key: "action",
                    align: "center",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small"
                                    },
                                    style: {
                                        marginRight: "5px"
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row);
                                        }
                                    }
                                },
                                "编辑"
                            ),
                            // h(
                            //     "Button",
                            //     {
                            //         props: {
                            //             type: "error",
                            //             size: "small"
                            //         },
                            //
                            //         on: {
                            //             click: () => {
                            //                 this.del(params.row);
                            //             }
                            //         }
                            //     },
                            //     "删除"
                            // )
                        ]);
                    }
                }],
            data: [], // 表单数据
            total: 0 // 表单数据总数
        }
    },
    methods: {
        init() {
            this.getDataList();
        },
        getDataList() {
            this.loading = true;
            textList(this.searchForm).then(res => {
                this.loading = false;
                if (res.status === true) {
                    this.data = res.data.rows;
                    this.total = res.data.total;
                }
            });
        },

        edit(v) {
            this.$refs.indextagDrawer.showDrawer(v);
        },
        add() {
            this.$refs.indextagDrawer.showDrawer();
        },
        del(v) {
            console.log("删除", v)
            this.$Modal.confirm({
                title: "确认删除",
                content: "您确认要删除模块 " + v.title + " ?",
                onOk: () => {

                    delIndex({ids: v.id}).then(res => {
                        if (res.status === true) {
                            this.$Message.success("删除成功");
                            this.getDataList();
                        }
                    });
                }
            });
        },
        //设置课程推荐状态
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = 10;
            this.getDataList();
        },
        handleReset() {
            this.$refs.searchForm.resetFields();
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = 10;
            this.selectDate = null;
            this.searchForm.startDate = "";
            this.searchForm.endDate = "";
            // 重新加载数据
            this.getDataList();
        },
        dropDown() {
            if (this.drop) {
                this.dropDownContent = "展开";
                this.dropDownIcon = "ios-arrow-down";
            } else {
                this.dropDownContent = "收起";
                this.dropDownIcon = "ios-arrow-up";
            }
            this.drop = !this.drop;
        },
        changePage(v) {
            this.searchForm.pageNumber = v;
            this.getDataList();
            this.clearSelectAll();
        },
        changePageSize(v) {
            this.searchForm.pageSize = v;
            this.getDataList();
        },
        changeSort(e) {
            this.searchForm.sort = e.key;
            this.searchForm.order = e.order;
            if (e.order === "normal") {
                this.searchForm.order = "";
            }
            this.getDataList();
        },
        showSelect(e) {
            this.selectList = e;
            this.selectCount = e.length;
        },
        clearSelectAll() {
            this.$refs.table.selectAll(false);
        },
        showPic(v) {
            this.img = v;
            this.picVisible = true;
        },
        //上架 下架
        setStatus(row, v) {
            let params = {
                id: row.id,
                deleted: row.deleted,
            };
            editTextStatus(params).then((res) => {
                if (res.status === true) {
                    this.$Message.success(res.info);
                }
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>
